import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { AdminUserSimpleFormContent } from "./components/AdminUserSimpleFormContent";

export function AdminUserCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <AdminUserSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
